import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";

// Frankfurter (https://frankfurter.dev) — free, keyless exchange-rate API
// blending central-bank reference rates. Called directly from the browser
// (CORS is open); nothing goes through the BFF.
//
// GET /v2/rates?base=EUR&quotes=NOK&from=YYYY-MM-DD&to=YYYY-MM-DD returns one
// entry per calendar day in the range (weekends carry the last published
// rate); a `to` in the future is silently clamped to the latest day.

export const FRANKFURTER_BASE_URL = "https://api.frankfurter.dev/v2";

export type FrankfurterRate = {
    /** YYYY-MM-DD */
    date: string;
    base: string;
    quote: string;
    /** 1 base = rate quote */
    rate: number;
};

export type GetRatesArgs = {
    base: string;
    quote: string;
    /** YYYY-MM-DD, inclusive */
    from: string;
    /** YYYY-MM-DD, inclusive */
    to: string;
};

export const frankfurterApi = createApi({
    reducerPath: "frankfurterApi",
    baseQuery: fetchBaseQuery({baseUrl: FRANKFURTER_BASE_URL}),
    endpoints: (builder) => ({
        getRates: builder.query<FrankfurterRate[], GetRatesArgs>({
            query: ({base, quote, from, to}) => ({
                url: "/rates",
                params: {base, quotes: quote, from, to},
            }),
            // Rates are published once a day; an hour is plenty.
            keepUnusedDataFor: 3600,
        }),
    }),
});
